import {
  formatOverallAnalysisCellDisplay,
  getOverallAnalysisFixedColumnValue,
  getOverallAnalysisTableAttributeColumns,
  OVERALL_ANALYSIS_LEADING_FIXED_TABLE_COLUMNS,
  OVERALL_ANALYSIS_TRAILING_FIXED_TABLE_COLUMNS,
} from "../../../utils/trendSidebarGraphUtils/overallAnalysisColumns";

type BarData = {
  [key: string]: string;
};

type Props = {
  dynamicColumns: string[];
  barData: BarData[];
  selectedMaterials?: string[];
};

const renderFixedCells = (
  row: BarData,
  columns: typeof OVERALL_ANALYSIS_LEADING_FIXED_TABLE_COLUMNS
) =>
  columns.map(({ formatKey }) => (
    <td
      key={formatKey}
      className="p-2 border border-gray-300 text-center text-sm text-gray-700"
    >
      {formatOverallAnalysisCellDisplay(
        formatKey,
        getOverallAnalysisFixedColumnValue(
          row as Record<string, unknown>,
          formatKey
        )
      )}
    </td>
  ));

const OverallAnalysisTable = ({
  dynamicColumns,
  barData,
  selectedMaterials,
}: Props) => {
  const attributeColumns = getOverallAnalysisTableAttributeColumns(
    dynamicColumns,
    selectedMaterials
  );

  return (
    <div className="pt-4 mx-4 font-poppins mb-5">
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-300 bg-white">
          <thead className="text-sm font-bold text-gray-800 bg-white">
            <tr>
              {OVERALL_ANALYSIS_LEADING_FIXED_TABLE_COLUMNS.map(
                ({ headerLabel }) => (
                  <th
                    key={headerLabel}
                    className="whitespace-nowrap p-2 border border-gray-300 text-center"
                  >
                    {headerLabel}
                  </th>
                )
              )}
              {attributeColumns.map(column => (
                <th
                  key={column}
                  className="whitespace-nowrap p-2 border border-gray-300 text-center"
                >
                  {column}
                </th>
              ))}
              {OVERALL_ANALYSIS_TRAILING_FIXED_TABLE_COLUMNS.map(
                ({ headerLabel }) => (
                  <th
                    key={headerLabel}
                    className="whitespace-nowrap p-2 border border-gray-300 text-center"
                  >
                    {headerLabel}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {barData.map((row, index) => (
              <tr
                key={index}
                className="border border-gray-300 text-center hover:bg-gray-200 transition-colors"
              >
                {renderFixedCells(
                  row,
                  OVERALL_ANALYSIS_LEADING_FIXED_TABLE_COLUMNS
                )}
                {attributeColumns.map(column => (
                  <td
                    key={column}
                    className="p-2 border border-gray-300 text-center text-sm text-gray-700"
                  >
                    {formatOverallAnalysisCellDisplay(
                      column,
                      (row as Record<string, unknown>)[column]
                    )}
                  </td>
                ))}
                {renderFixedCells(
                  row,
                  OVERALL_ANALYSIS_TRAILING_FIXED_TABLE_COLUMNS
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OverallAnalysisTable;
